import { render, staticRenderFns } from "./DataSubmittedMessage.vue?vue&type=template&id=b67018fc&scoped=true"
import script from "./DataSubmittedMessage.vue?vue&type=script&lang=js"
export * from "./DataSubmittedMessage.vue?vue&type=script&lang=js"
import style0 from "./DataSubmittedMessage.vue?vue&type=style&index=0&id=b67018fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67018fc",
  null
  
)

export default component.exports